<template>
  <p class="text-primary">
    <slot />
  </p>
</template>

<script>
export default {
  name: "CoreHeading",
};
</script>

<style lang="scss" scoped></style>
